/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div>
    <div class="item-position splitLine-top"></div>
    <div class="item-position logo-item" ><img src="/static/img/sadaLogo.png"/></div>
    <div class="item-position project-name">{{projectGroupInfo.name}}</div>
    <div class="item-position project-status">
      <span>项目组成：</span>
      <template v-for="(item, index) in projectGroupInfo.projectSet">
        <span v-if="index === projectGroupInfo.projectSet.length - 1" :key="index" :class="item.id === current ? 'current' : 'noCurrent'">{{item.name}}</span>
        <span v-else :key="index" :class="item.id === current ? 'current' : 'noCurrent'">{{item.name}}、</span>
      </template>
    </div>
    <div class="item-position splitLine-bottom"></div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
const dateFormat = 'YYYY-MM-DD HH:mm:ss'
export default {
  name: 'Header',
  data () {
    return {
      time: dayjs().format(dateFormat)
    }
  },
  props: {
    projectGroupInfo: {
      type: Object
    },
    current: {
      type: Number
    }
  }
}
</script>

<style scoped lang="scss">
  .splitLine-top{
    left:0;
    top:20px;
    width:1800px;
    height:2px;
    background: url("/static/img/splitLine4.png") no-repeat;
    background-size: 100% 100%;
    filter: blur(1px);
  }
  .splitLine-bottom{
    left:0;
    top:120px;
    width:1400px;
    height:2px;
    background: url("/static/img/splitLine4.png") no-repeat;
    background-size: 100% 100%;
    filter: blur(1px);
  }
  .logo-item{
    left: 20px;
    top: 30px;
    height: 80px;
    width: 150px;
    display: flex;
    align-items: center;
    img {
      width: 100%
    }
  }
  .project-name{
    left: 210px;
    top: 38px;
    font-size: 35px;
    font-weight: 500;
  }
  .project-status{
    left: 210px;
    top: 90px;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    & > div:first-child{
      width: 15px;
      height:15px;
      background-size: 100% 100% !important;
      margin-right: 10px;
    }
    /*前端简介限制字数在50个以内*/
    .dec-item{
      display: flex;
      div:last-child{
        width: 700px;
        height: 19px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .current {
    color: #fff
  }
  .noCurrent {
    color: #5f7f9b
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue